/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {ADMIN_RESOURCE_PAGES} from '../common/controller/admin-resource-pages';
import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {PoliticalEntityModel} from './political-entity-api.service';
import {PoliticalEntityCampaignsPanelComponent} from './political-entity-campaigns-panel.component';
import {PoliticalEntityEditPageComponent} from './political-entity-edit-page.component';

@Component({
  standalone: true,
  imports: [
    ...ADMIN_RESOURCE_PAGES,
    PoliticalEntityCampaignsPanelComponent,
    PoliticalEntityEditPageComponent
  ],
  selector: 'adn-political-entity-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-political-entity-edit-page leftPanel [state]="state"></adn-political-entity-edit-page>
      <adn-political-entity-campaigns-panel rightPanel [model]="state.model()" [isNew]="state.isNew()"></adn-political-entity-campaigns-panel>
    </adn-two-panel-layout>
  `
})
export class PoliticalEntityItemPageComponent {
  @Input() state: SignalAdminResourcePageState<PoliticalEntityModel>;
}
